import { useState } from 'react';
import './register.scss';
import { ArrowRight, Building2, Eye, EyeClosed, Shield, User } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { CreateUser } from '../../../models/User';
import { useAppDispatch, useAppSelector } from '../../../features/helpers';
import { UserAddInfo } from '../../admin/admin-list-user/adminListUser';
import { makeCompanyRegister, makeUserRegister } from '../../../store/AuthSlice';



export const Register = () => {

    const dispatch = useAppDispatch();

    const [accountType, setAccountType]         = useState<"individual" | "company">("individual");
    const [showPassword, setShowPassword]       = useState(false);
    const [showConfirm, setShowConfirm]         = useState(false);

    const navigate = useNavigate();

    const goTologin = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        navigate("/");
    }

    function validateEmail(value:string) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(value)) {
            setError("Invalid email");
        } else {
            setError("");
        }
    }

    // user register
    const [email, setEmail]             = useState("");
    const [error, setError]             = useState("");
    const [formError, setFormError]     = useState("");

    const loadingStatus                 = useAppSelector( (state) => state.user.loading)

    const [form, setForm] = useState<UserAddInfo>({
        name: "",
        login: "",
        email: "",
        password: "",
        confirm: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // company register

    // form submit
    const handleSubmit = async () => {
        if (loadingStatus.register) return;

        if (!form.name || !form.email || !form.password) {
            setFormError(accountType === 'company'
                ? 'Preencha o nome da empresa, e-mail e senha.'
                : 'Preencha nome, e-mail e senha.');
            return;
        }
        if (form.password !== form.confirm) {
            setFormError('As senhas nao conferem.');
            return;
        }
        setFormError('');

        // Registro publico: /auth/register/user (pessoa) ou /auth/register/company
        // (empresa). Ambos ja devolvem uma sessao logada. O backend exige senha
        // >= 8 chars com letra e digito — o erro volta em res.error.
        const res = accountType === 'company'
            ? await dispatch(makeCompanyRegister(
                form.name,
                { name: form.name, email: form.email, password: form.password ?? '' },
              ))
            : await dispatch(makeUserRegister(form.name, form.email, form.password ?? ''));

        if (res.ok) navigate('/');
        else setFormError(res.error ?? 'Falha no registro.');
    }

    return (
        <div className="register-wrapper">

            <div className="form">

                <div className="title">
                    <div className="title-name">
                        <Shield className='icon' size={32} />
                        <span className="title-text">Tabletop</span>
                    </div>
                    <h1 className="subtitle">Crie sua conta</h1>
                    <p className="subtitle-small">Crie sua conta na plataforma Tabletop e comece a transacionar com segurança</p>
                </div>

                <div className="glow"></div>

                <div className="card">

                    <div className="selection form-line flex">
                        <div className={`button-shadow ${accountType === 'individual' ? 'left' : 'right'}`}></div>
                        {(["individual", "company"] as const).map((type) => (
                            <button
                                key={type}
                                onClick={() => setAccountType(type)}
                                className={type === accountType ? "active" : ""}
                            >
                                {type === "individual" ? <User className="icon" /> : <Building2 className="icon" />}
                                {type === "individual" ? "Individual" : "Company"}
                            </button>
                        ))}
                    </div>

                    <div className="form-body">

                        <div className="models">

                            {/* user  */}
                            <div className={`${accountType === "individual" ? "active" : ""} user`}>
                                <div className="form-group flex">
                                    <label htmlFor="name">Nome</label>
                                    <input type="text" id="name" name="name" placeholder="Digite seu nome completo" onChange={handleChange} value={form.name} />
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="login">Login</label>
                                    <input type="text" id="login" name='login' placeholder="Digite seu nome completo" onChange={handleChange} value={form.login}/>
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="email">E-mail</label>
                                    <input 
                                        type="text" 
                                        id="email" 
                                        name="email" 
                                        placeholder="Digite seu e-mail"
                                        value={form.email}
                                        onChange={(e) => {
                                            handleChange(e);
                                            validateEmail(e.target.value);
                                        }} />
                                    {error && <span className='text-danger'>{error}</span>}
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="password">Senha</label>
                                    <input 
                                        type={showPassword ? "text" : "password"} 
                                        id="password" 
                                        name="password" 
                                        placeholder="Digite sua senha" 
                                        onChange={handleChange} 
                                        value={form.password}/>
                                    {showPassword ? <Eye className="icon" size={20} onClick={() => setShowPassword(!showPassword)} /> : <EyeClosed className="icon" size={20} onClick={() => setShowPassword(!showPassword)} />}
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="confirm">Confirme a senha</label>
                                    <input 
                                        type={showConfirm ? "text" : "password"} 
                                        id="confirm" 
                                        name="confirm" 
                                        placeholder="Digite sua senha novamente"
                                        onChange={handleChange}
                                        value={form.confirm}/>
                                    {showConfirm ? <Eye className="icon" size={20} onClick={() => setShowConfirm(!showConfirm)} /> : <EyeClosed className="icon" size={20} onClick={() => setShowConfirm(!showConfirm)} />}
                                </div>
                            </div>

                            {/* company  */}
                            <div className={`${accountType === "company" ? "active" : ""} company`}>
                                <div className="form-group flex">
                                    <label htmlFor="c-name">Nome da Empresa</label>
                                    <input type="text" id="c-name" name="name" placeholder="Digite o nome da empresa" onChange={handleChange} value={form.name} />
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="c-email">E-mail</label>
                                    <input type="text" id="c-email" name="email" placeholder="Digite seu e-mail" onChange={handleChange} value={form.email} />
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="c-password">Senha</label>
                                    <input type={showPassword ? "text" : "password"} id="c-password" name="password" placeholder="Digite sua senha" onChange={handleChange} value={form.password} />
                                    {showPassword ? <Eye className="icon" size={20} onClick={() => setShowPassword(!showPassword)} /> : <EyeClosed className="icon" size={20} onClick={() => setShowPassword(!showPassword)} />}
                                </div>
                                <div className="form-group flex">
                                    <label htmlFor="c-confirm">Confirme a senha</label>
                                    <input type={showConfirm ? "text" : "password"} id="c-confirm" name="confirm" placeholder="Digite sua senha novamente" onChange={handleChange} value={form.confirm} />
                                    {showConfirm ? <Eye className="icon" size={20} onClick={() => setShowConfirm(!showConfirm)} /> : <EyeClosed className="icon" size={20} onClick={() => setShowConfirm(!showConfirm)} />}
                                </div>
                            </div>

                        </div>

                    </div>
                    
                    <div className="bottom">
                        <button className="submit" onClick={handleSubmit} disabled={loadingStatus.register ? true : false}>
                            Criar Conta <ArrowRight className="icon" size={20} />
                        </button>
                        {formError && <span className='text-danger'>{formError}</span>}
                        <p className="text-center text-sm text-muted-foreground mt-6">
                            Já tem uma conta?
                            <a href="" onClick={goTologin} className="">Sign in</a>
                        </p>
                    </div>

                </div>



            </div>

        </div>
    )
};

export default Register;